import { updateMerchantProductStatus } from 'services/api/merchants/products';
import { ProductPayloadUpdateStatus } from 'services/api/merchants/products/types-product-update-status';

export function updateProductStatus({ productId, body }: ProductPayloadUpdateStatus) {
  return updateMerchantProductStatus({ productId, body });
}
